export default __webpack_public_path__ + "static/media/carousel-img1.b4027da0.png";